import { yup } from '@comptia-sso/core';
import { TFunction } from 'react-i18next';

export const getValidationSchema = (t: TFunction): yup.SchemaOf<unknown> =>
  yup.object().shape({
    country: yup.string().required(t('Validation.Required')).isValidCountry(t),
  });
